import { gql } from '@apollo/client';

export const REJECT_WAITING_LIST_APPROVAL = gql`
  mutation rejectWaitingListApproval($id: ID!) {
    rejectWaitingListApproval(id: $id)
  }
`;
